module.exports = __webpack_public_path__ + "static/img/3-480.5b41170e.jpg";